import { USER_ACCOUNT_STATUSES } from "@artisancode/api-types";
import { DEFAULT_COUNTRY_CODE } from "@artisancode/phone";
import { z } from "zod";

export function buildUserSchema(isEditing: boolean) {
  return z.object({
    name: z.string().min(3, "Nama minimal 3 karakter"),
    email: z.email("Email tidak valid"),
    phone: z.string().min(1, "Nomor telepon wajib diisi"),
    countryCode: z.string().min(1, "Kode negara wajib dipilih"),
    password: isEditing
      ? z.string().optional()
      : z.string().min(6, "Password minimal 6 karakter"),
    roleIds: z.array(z.string()).min(1, "Pilih minimal 1 role"),
    status: z.enum(USER_ACCOUNT_STATUSES),
    workspaceId: z.string().min(1, "Workspace wajib dipilih"),
  });
}

export type UserFormValues = z.infer<ReturnType<typeof buildUserSchema>>;

export const defaultUserValues: UserFormValues = {
  name: "",
  email: "",
  phone: "",
  countryCode: DEFAULT_COUNTRY_CODE,
  password: "",
  roleIds: [],
  status: "active",
  workspaceId: "",
};
